// removed by extract-text-webpack-plugin
module.exports = {"blue":"background__blue___1KG0e bg-blue","green":"background__green___MZ0av bg-green","red":"background__red___3swk5 bg-red","smoke":"background__smoke___AvtQa bg-smoke","darkSmoke":"background__darkSmoke___1UcIB bg-smoke--d","extraDarkSmoke":"background__extraDarkSmoke___1sDf2 bg-smoke--xd","slate":"background__slate___3CIgg bg-slate","white":"background__white___2PlBY bg-white","negative":"background__negative___2LCdh bg-negative"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/Button/style/background.css
// module id = 113
// module chunks = 0 2